import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../assets/styles/theme';
import { makeTransparentColor } from '../../../assets/styles/transparentColor';
import { formatPrice } from '../../../utils/priceFormatter';
import { TextMain } from '../../typography/Texts';

const AmountText = styled(TextMain)`
  color: ${makeTransparentColor(theme.color.black, 0.5)};
  font-weight: 700;
`;

interface Props {
  amount: number;
}

const BidAmountInfo = ({ amount }: Props) => {
  return <AmountText>{formatPrice(amount)}</AmountText>;
};

export default BidAmountInfo;
